import * as React from "react";
import { RefreshCw } from "lucide-react";

import { Button } from "@/components/ui/button";

/** Bare refresh icon (no button fill/border, just the glyph in the theme's
 *  primary color) for a page's header, next to its title - re-runs the
 *  fetch a `PageHeader`'s page already has, so refreshing a table's data
 *  never requires a full page reload (which would also lose the table's
 *  own sort/search/page position - see DataTable's persistKey). Pass
 *  whichever load callback is relevant to what's currently visible (e.g.
 *  the active tab's own fetch, on a page with more than one table). */
export function RefreshButton({
  onRefresh,
  isLoading = false
}: {
  onRefresh: () => void;
  isLoading?: boolean;
}) {
  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-8 w-8 shrink-0 text-primary hover:text-primary"
      onClick={onRefresh}
      disabled={isLoading}
      title="Refresh"
    >
      <RefreshCw className={`h-4 w-4 ${isLoading ? "animate-spin" : ""}`} />
      <span className="sr-only">Refresh</span>
    </Button>
  );
}
